
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[code]",
      function () {
        return require("private-next-pages/c/[code]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[code]"])
      });
    }
  